import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CandidateShowingsComponent } from './components/candidateShowings/candidateShowings.component';
import { ShowingItemComponent } from './components/candidateShowings/showingItem/showingItem.component';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../shared/shared.module';
import { MaterialModule } from '../material.module';
import { LoaderModule } from '../shared/components/loader/loader.module';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    SharedModule,
    MaterialModule,
    LoaderModule
  ],
  declarations: [CandidateShowingsComponent, ShowingItemComponent],
  exports: [CandidateShowingsComponent]
})
export class CandidateModule { }
